// TODO: Find a solution to declare that the result is the same value.
// For now, this approach removes the error also breaks type safety.
function important(value) {
    return (value + ' !important');
}
export const utils = {
    important,
};
